export default __webpack_public_path__ + "static/media/btn-zeroback-start-nl_dt@2x.7f83211a.png";